import React, { CSSProperties, useEffect } from 'react'
import { Link, useParams, useHistory } from 'react-router-dom'
import { Helmet } from 'react-helmet'
import { useTranslation } from 'react-i18next'
import { LangValue } from '../../states/types/common'

import { URL } from '../constants/url'
import { setPath } from '../../utils/url'

const style = {
  root: {
    marginTop: 20,
    textAlign: 'center',
  } as CSSProperties,
}

const redirectExcludeList = [
  URL.MICROSOFT_CALLBACK.path,
  URL.GOOGLE_CALLBACK.path,
  URL.LOGIN_MICROSOFT_CALLBACK.path,
  URL.LOGIN_GOOGLE_CALLBACK.path,
]
const Error: React.FC = () => {
  const { t } = useTranslation()
  const history = useHistory()
  const { language } = useParams<{ language: LangValue }>()

  useEffect(() => {
    if (redirectExcludeList.includes(location.pathname)) return
    if (language.length === 2) return
    history.push(`/ja${location.pathname}`)
  }, [])

  return (
    <div style={style.root}>
      <Helmet>
        <title>{t('layouts.error.title')}</title>
        <meta name="keywords" content={t('layouts.error.title')} />
        <meta name="description" content={t('layouts.error.title')} />
      </Helmet>

      <p>{t('layouts.error.description')}</p>
      <Link
        to={setPath(URL.TOP.path, language)}
        color="primary"
      >
        {t('layouts.error.back')}
      </Link>
    </div>
  )
}

export default Error
